import React from 'react'

interface MissedChatBannerProps {
  missedAt: string
  missedReason?: string
  onReply?: () => void
  onAssign?: () => void
}

export const MissedChatBanner: React.FC<MissedChatBannerProps> = ({ missedAt, missedReason, onReply, onAssign }) => {
  return (
    <div className="mx-4 my-2 px-4 py-3 rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 animate-slide-up">
      <div className="flex items-center gap-2 mb-1">
        <svg className="w-4 h-4 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
        </svg>
        <span className="text-sm font-semibold text-red-700 dark:text-red-300">CHAT MISSED</span>
        <span className="text-xs text-red-500 ml-auto">{new Date(missedAt).toLocaleString()}</span>
      </div>
      {missedReason && (
        <p className="text-xs text-red-600 dark:text-red-400 mb-2">Reason: {missedReason}</p>
      )}
      <div className="flex items-center gap-2">
        {onReply && (
          <button onClick={onReply} className="px-3 py-1 rounded-md text-xs font-medium bg-red-600 text-white hover:bg-red-700 transition-colors">
            Reply via Email
          </button>
        )}
        {onAssign && (
          <button onClick={onAssign} className="px-3 py-1 rounded-md text-xs font-medium text-red-700 border border-red-300 hover:bg-red-100 dark:text-red-300 dark:border-red-700 dark:hover:bg-red-900/30 transition-colors">
            Assign to Agent
          </button>
        )}
      </div>
    </div>
  )
}
